<script>
	//Start Modules Import
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import ErrorMessageHandler from "../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import Loader from "../../components/Loader/Loader.svelte";
	import PageHeader from "../../components/PageHeader/PageHeader.svelte";
	import client from "../../services/client";
	import { errorMessage, loading } from "../../store/store";
	import { navigate } from "svelte-routing";
	import SveltyPicker from "svelty-picker";
	import { form, field } from "svelte-forms";
	import { required, email, pattern } from "svelte-forms/validators";
	import { extractErrorMessage } from "src/utils/misc";
	import { onMount } from "svelte";
	import CustomInput from "../../components/CustomInput/CustomInput.svelte";
	import CustomSelect from "../../components/CustomSelect/CustomSelect.svelte";
	import { convertDateOnly } from "src/services/helpers";
	import { brand } from "src/brand";

	export let isEdit;

	//End Modules import

	//Start Variables

	//Define form validations using svelte-forms library
	const fullName = field("fullName", "", [required()]);
	const drivingLicenseClass = field("drivingLicenseClass", "", [required()]);
	const drivingLicenseNumber = field("drivingLicenseNumber", "", [
		required(),
	]);
	const drivingLicenseExpiryDate = field(
		"drivingLicenseExpiryDate",
		null,
		[]
	);
	const countryCode = field("countryCode", brand.defaultCountryCode, [
		required(),
	]);
	const mobileNumber = field("mobileNumber", "", [
		required(),
		pattern(brand.mobileValidation.pattern),
	]);
	const userEmail = field("userEmail", "", [required(), email()]);
	const address = field("address", "", [required()]);
	const unitNumber = field("unitNumber", "", [required()]);
	const postalCode = field("postalCode", "", [
		required(),
		pattern(/^[0-9]{6}$/),
	]);
	let emailUsed;
	let mobileNumberUsed;
	let expiredLicense;
	let today = new Date();
	let isExpired = false;

	const myForm = form(
		fullName,
		drivingLicenseClass,
		drivingLicenseNumber,
		drivingLicenseExpiryDate,
		countryCode,
		mobileNumber,
		userEmail,
		address,
		unitNumber,
		postalCode
	);

	let load = false;
	loading.subscribe((value) => {
		load = value;
	});

	async function handleSubmit(values) {
		try {
			let data = {
				fullName: $fullName.value,
				drivingLicenseClass: parseInt($drivingLicenseClass.value),
				drivingLicenseNumber: $drivingLicenseNumber.value,
				drivingLicenseExpiry: $drivingLicenseExpiryDate.value,
				DrivingLicenceClass: parseInt($drivingLicenseClass.value),
				DrivingLicenceNumber: $drivingLicenseNumber.value,
				drivingLicenceExpiry: $drivingLicenseExpiryDate.value,
				countryCode: $countryCode.value,
				mobileNumber: $mobileNumber.value,
				email: $userEmail.value,
				address: $address.value,
				unitNumber: $unitNumber.value,
				postalCode: $postalCode.value,
			};
			if (isEdit) {
				data.id = isEdit;
			}
			loading.set(true);
			const res = await client(
				`/v0/Auth/${isEdit ? "EditUser" : "AdminCreate"}`,
				{
					method: "POST",
					version: "Tasking",
					data,
				}
			);
			if (res.status === 200) {
				navigate("/account/account-management");
			}
		} catch (err) {
			loading.set(false);
			console.log(err.response);
			extractErrorMessage(err);
		}
	}

	async function fetchUser() {
		try {
			const res = await client(`/v0/Auth/GetUser?id=${isEdit}`, {
				method: "POST",
				version: "Tasking",
			});
			let data = res.data.data;
			$fullName.value = data.fullName;
			$countryCode.value = data.countryCode || brand.defaultCountryCode;
			$mobileNumber.value = data.mobileNumber;
			$userEmail.value = data.email;
			$address.value = data.address;
			$unitNumber.value = data.unitNumber;
			$postalCode.value = data.postalCode;
			$drivingLicenseNumber.value = !data.drivingLicenseNumber
				? ""
				: data.drivingLicenseNumber;
			$drivingLicenseClass.value = data.drivingLicenseClass.toString();
			$drivingLicenseExpiryDate.value = convertDateOnly(
				data.drivingLicenseExpiry,
				"YYYY-MM-DD"
			);
		} catch (error) {
			extractErrorMessage(error);
			console.log(error);
		}
	}

	onMount(() => {
		if (isEdit) {
			fetchUser();
		}
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col>
		<ErrorMessageHandler message={err} />
		<div>
			<PageHeader title={`${isEdit ? "Edit" : "Create"} User`} />
			<Col>
				<Row>
					<Col>
						<label for="fullName" class="d-block">
							<span> Full Name* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$fullName.value}
							error={$myForm.hasError("fullName.required")}
							errorText="Full name is required"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="countryCode" class="d-block">
							<span> Country Code* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$countryCode.value}
							on:input={countryCode.validate}
							error={$myForm.hasError("countryCode.required")}
							errorText="Country code is required"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="mobileNumber" class="d-block">
							<span> Mobile Number* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$mobileNumber.value}
							on:input={mobileNumber.validate}
							error={$myForm.hasError("mobileNumber.required") ||
								$myForm.hasError("mobileNumber.pattern") ||
								mobileNumberUsed}
							errorText={$myForm.hasError("mobileNumber.required")
								? "Mobile number is required"
								: $myForm.hasError("mobileNumber.pattern")
									? brand.mobileValidation.message
									: mobileNumberUsed}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="email" class="d-block">
							<span> Email* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="email"
							bind:value={$userEmail.value}
							on:input={userEmail.validate}
							error={$myForm.hasError("userEmail.required") ||
								$myForm.hasError("userEmail.not_an_email") ||
								emailUsed}
							errorText={$myForm.hasError("userEmail.required")
								? "Email is required"
								: $myForm.hasError("userEmail.not_an_email")
									? "Must be a valid email"
									: emailUsed}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="address" class="d-block">
							<span> Address* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$address.value}
							error={$myForm.hasError("address.required")}
							errorText="Address is required"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="unitNumber" class="d-block">
							<span> Unit Number* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$unitNumber.value}
							error={$myForm.hasError("unitNumber.required")}
							errorText="Unit number is required"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="postalCode" class="d-block">
							<span> Postal Code* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$postalCode.value}
							on:input={postalCode.validate}
							error={$myForm.hasError("postalCode.required") ||
								$myForm.hasError("postalCode.pattern")}
							errorText={$myForm.hasError("postalCode.required")
								? "Postal code is required"
								: $myForm.hasError("postalCode.pattern")
									? "Postal code must be 6 digits number"
									: ""}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="drivingLicenseNumber" class="d-block">
							<span> Driving licence Number* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$drivingLicenseNumber.value}
							error={$myForm.hasError(
								"drivingLicenseNumber.required"
							)}
							errorText="Driving licence number is required"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="drivingLicenseClass" class="d-block">
							<span> Driving License Class* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomSelect
							type="text"
							bind:value={$drivingLicenseClass.value}
							options={brand.drivingLicenceClassOptions}
							error={$myForm.hasError(
								"drivingLicenseClass.required"
							)}
							errorText="Driving licence class is required"
							defaultOption="Select class"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="drivingLicenseExpiry" class="d-block">
							<span> Driving License Expiry </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<SveltyPicker
							inputClasses="form-control getgo input {expiredLicense ||
							isExpired
								? 'border border-danger'
								: ''}"
							format="yyyy-mm-dd"
							bind:value={$drivingLicenseExpiryDate.value}
							placeholder="YYYY-MM-DD"
							on:change={() =>
								new Date($drivingLicenseExpiryDate.value) <
								!$drivingLicenseExpiryDate.value
									? (isExpired = false)
									: new Date(
												$drivingLicenseExpiryDate.value
										  ) < today
										? (isExpired = true)
										: (isExpired = false)}
						/>
						{#if expiredLicense}
							<div>
								<p class="error-text">
									{expiredLicense}
								</p>
							</div>
						{:else if isExpired}
							<div>
								<p class="error-text">
									The driving licence has expired
								</p>
							</div>
						{/if}
					</Col>
				</Row>
			</Col>
			<Col class="d-flex justify-content-end">
				<Row>
					<Col>
						<Button class="themeButton" on:click={myForm.reset}
							>RESET</Button
						>
						<Button
							class="themeButton primary"
							disabled={!$myForm.valid}
							on:click={() => handleSubmit()}
							on:click={myForm.validate}
						>
							{#if load}
								<Loader />
							{:else}
								{isEdit ? "EDIT" : "CREATE"}
							{/if}
						</Button>
					</Col>
				</Row>
			</Col>
		</div>
	</Col>
</Row>
